import { IEditPackageDetails } from '../interfaces/packages';
import { AvailabilityType } from '../constants/packages';
import { IObject } from 'common/interfaces/common';
import { DeepPartial } from 'react-hook-form';

export const transformPackageDetailToDTO = (
  packageDetail: DeepPartial<IEditPackageDetails>,
): IObject => {
  const packageDTO: IObject = { ...packageDetail };

  packageDTO.generalSection.allowAllEmployee = !packageDetail.generalSection?.employees?.length;
  packageDTO.generalSection.allowAccessAllClubs = !packageDetail.generalSection?.accessClubs
    ?.length;
  packageDTO.generalSection.allowSellInAllClubs = !packageDetail.generalSection?.sellerClubs
    ?.length;

  if (packageDTO.serviceSection) {
    packageDTO.serviceSection.includedServices = packageDetail.serviceSection?.includedServices?.map(
      includedService => ({
        ...includedService,
        hasCustomDayTimeAvailability: !!includedService?.dayTimeAvailDtoList?.length,
      }),
    );
  }

  return packageDTO;
};

export const transformPackageDetailFromDTO = (packageDetailDTO): IEditPackageDetails => {
  const packageDetail = { ...packageDetailDTO };

  packageDetail.generalSection.availabilityType = packageDetailDTO.generalSection?.endDate
    ? AvailabilityType.ForRange
    : AvailabilityType.StartingOnDate;

  return packageDetail;
};
